/* eslint-disable */
import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import insightsChartData from '../../../../../helpers/effectReports/insightsChartData';
import { convertTypeString } from '../../../../../helpers/helpers';
import { useReportContext } from '../../../../../hooks/useReport';
import { Analysis } from '../../../../../services/reports';
import EffectRadarChart from '../../../SharedEffectReportComponents/EffectReportTemplate/EffectProgressTable/EffectRadarChart/EffectRadarChart';
import ValueColorBlocks from '../../../SharedEffectReportComponents/EffectReportTemplate/ReportTimestemps/ValueColorBlocks/ValueColorBlocks';
import {
  BottomWrapper,
  Description,
  DescriptionSegment,
  DescriptionWrapper,
  Header,
  RadarChartWrapper,
  ShowButton,
  Wrapper,
} from './EffectFiveChallenges.styles';

interface EffectInsightsTemplateProps {
  data: Analysis;
  dotsData: {
    clarity?: Analysis;
    quality?: Analysis;
    relationship?: Analysis;
    behaving?: Analysis;
    learning?: Analysis;
  };
  onChallengeClick: (index: number) => void;
}

const EffectInsightsTemplate: React.FC<EffectInsightsTemplateProps> = ({
  data,
  dotsData,
  onChallengeClick,
}) => {
  const { effectData } = useReportContext();
  const { t } = useTranslation();
  const parsedData = insightsChartData(dotsData, effectData);

  const slicedDescription = data.description.split('<ol>');

  const [descriptionVisibility, setDescriptionVisibility] = useState<boolean>(false);

  const handleWrapDescription = () => {
    setDescriptionVisibility(state => !state);
  };
  const threshold_values = effectData?.topics[0].threshold_values;

  return (
    <>
      <Header>{t(`report.effect.topics.${convertTypeString(data.type)}`)}</Header>
      <Wrapper>
        <DescriptionSegment>
          <DescriptionWrapper>
            <Description
              dangerouslySetInnerHTML={{
                __html: descriptionVisibility ? data.description : slicedDescription[0],
              }}
            />
          </DescriptionWrapper>
          <BottomWrapper>
            {data.description.includes('<ol>') && (
              <ShowButton onClick={handleWrapDescription}>
                {descriptionVisibility
                  ? `${t('report.effect.buttons.showLess')} <<`
                  : `${t('report.effect.buttons.showMore')} >>`}
              </ShowButton>
            )}
            <ValueColorBlocks shape="square" direction="row" flattened={true} data={data} />
          </BottomWrapper>
        </DescriptionSegment>
        <RadarChartWrapper>
          <EffectRadarChart
            data={parsedData}
            threshold_values={threshold_values}
            onDotClick={onChallengeClick}
          />
        </RadarChartWrapper>
      </Wrapper>
    </>
  );
};

export default EffectInsightsTemplate;
